import fetch  from "../utils/fetch";


export function findByCondition(params) {
  return fetch({
    method:'POST',
    url:'/customer/health-monitoring/findByCondition',
    data:params
  })
}

///basic/conf/cities
export function getCities(params) {
	return fetch({
		method:'GET',
		url:'/basic/conf/cities',
		params
	})
}

///basic/conf/provinces
export function getProvinces(params) {
	return fetch({
		method:'GET',
		url:'/basic/conf/provinces',
		params
	})
}
//，门店城市
export function selectCondition(params) {
	return fetch({
		method:'GET',
		url:'/project/selectCondition',
		params
	})
}
///project/select/list?cityCode 门店
export function mendianList(params) {
	return fetch({
		method:'GET',
		url:'/projectBasics/buildInfo',
		params
	})
}

///basic/conf/dic/transportation 返程交通方式
export function transportation(params) {
	return fetch({
		method:'GET',
		url:'/basic/conf/dic/transportation',
		params
	})
}

///customer/health-monitoring/statistics
export function statistics(params) {
	return fetch({
		method:'GET',
		url:'/customer/health-monitoring/statistics',
		params
	})
}

///customer/health-monitoring/updateBackInfo
export function updateBackInfo(params) {
  return fetch({
    method:'POST',
    url:'/customer/health-monitoring/updateBackInfo',
    data:params
  })
}

///customer/health-monitoring/findHelthRecord
export function findHelthRecord(params) {
	return fetch({
		method:'GET',
		url:'/customer/health-monitoring/findHelthRecord',
		params
	})
}
